import React from 'react';
import wrapWithProvider from '@Utils/Components/wrapWithProvider';
import DialogsListContainer from './DialogsListContainer';

const renderDialogsListContainer = wrapWithProvider(<DialogsListContainer />);

export default function init() {
  const root = document.createElement('section');
  root.setAttribute('class', 'react-dialogs-root');
  document.body.appendChild(root);
  renderDialogsListContainer(root);
}
